import { useMedia } from "react-use";

export const useChartHeight = () => {
  const isSmallScreen = useMedia('(max-width: 840px)');
  const height = isSmallScreen ? 'max(40vh, 430px)' : 'min(50vh, 700px)';
  return height;
}